import React, { ReactElement } from "react";
import { SingleBenefit } from "./singleBenefit";
import styles from "./benefitGroup.module.scss";
import classNames from "classnames";

export const BenefitGroup = (props: Props): ReactElement => {
  const { badgeIcon: BadgeIcon } = props;

  return (
    <section className={styles.base}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.badgeAndTitle}>
            <div className={styles.badge}>
              <BadgeIcon
                className={classNames({
                  [styles.blueIcon]: props.theme == "blue",
                  [styles.greenIcon]: props.theme == "green",
                })}
              />
              <p
                className={classNames(styles.badgeText, {
                  [styles.blueText]: props.theme == "blue",
                  [styles.greenText]: props.theme == "green",
                })}
              >
                {props.badgeText}
              </p>
            </div>
            <h2 className={styles.title}>{props.title}</h2>
          </div>
          <p className={styles.supportText}>{props.desc}</p>
        </div>
      </div>

      {props.benefits?.map((b, i) => (
        <SingleBenefit key={i} order={i} {...b} theme={props.theme} />
      ))}
    </section>
  );
};

interface Props {
  theme: "blue" | "green";
  badgeIcon: React.ElementType;
  badgeText: string;
  title: string;
  desc: string;
  benefits: {
    imageUrl: string;
    title: string;
    description: string;
    bullets: string[];
    anchor_tag?: string;
  }[];
}
